<span
  [class.inline]="inline"
  [class.disabled]="disabled"
  [attr.tabindex]="disabled ? -1 : 0"
  [attr.aria-disabled]="disabled"
  role="button"
  (click)="disabled ? undefined : action.emit()"
  (keydown)="onKeyDown($event)"
>
  @if (icon) {
    <mat-icon inline class="material-icons-outlined">{{ icon }}</mat-icon>
  }

  <ng-content></ng-content>
</span>
